import React from "react";
import {
  Box,
  Typography,
  Button,
  Container,
  Grid,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import guardImage9 from "../assets/securitycheck.jpg";

const googleFormLink = "https://forms.gle/juQW6MV4AeVaBEMA9";

function ApplyNow() {
  return (
    <Box>
      {/* Hero Section */}
      <Box
        sx={{
          position: "relative",
          height: { xs: "260px", md: "500px" },
          backgroundImage: `url(${guardImage9})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#fff",
          textAlign: "center",
        }}
      >
        <Box sx={{ position: "absolute", inset: 0, bgcolor: "rgba(0,0,0,0.4)" }} />
        <Typography
          sx={{
            position: "relative",
            zIndex: 1,
            fontWeight: "bold",
            px: 2,
            fontSize: { xs: "22px", sm: "28px", md: "40px" },
          }}
        >
          Join the LineGuard Security Team
        </Typography>
      </Box>

      {/* Intro + Image Section */}
      <Container sx={{ py: { xs: 6, md: 10 } }}>
        <Grid container spacing={5} alignItems="center">
          {/* Image */}
          {/* <Grid item xs={12} md={6}>
            <Box
              component="img"
              src={guardImage9}
              alt="Security Team"
              sx={{
                width: "100%",
                maxHeight: { xs: 260, md: 420 },
                maxWidth: { xs: 260, md: 420 },
                objectFit: "cover",
                borderRadius: 3,
                boxShadow: 3,
              }}
            />
          </Grid> */}

          {/* Content */}
          <Grid item xs={12} md={6}>
            <Typography
              sx={{
                mb: 2,
                fontWeight: "bold",
                color: "#002147",
                fontSize: { xs: "22px", md: "28px" },
              }}
            >
              Start Your Career in Professional Security
            </Typography>

            <Typography sx={{ mb: 2, lineHeight: 1.8 }}>
              LineGuard Security is always seeking motivated and dedicated
              individuals to join our growing team. Whether you are experienced
              or starting your career, we offer opportunities to grow and make a
              real impact.
            </Typography>

            <Typography sx={{ mb: 3, lineHeight: 1.8 }}>
              We are locally owned and operated with a strong focus on
              professionalism, integrity, and safety.
            </Typography>

            <Button
              variant="contained"
              href={googleFormLink}
              target="_blank"
              sx={{
                bgcolor: "#ffcc00",
                color: "#000",
                fontWeight: "bold",
                px: 4,
                py: 1.5,
                borderRadius: "30px",
                mb: 3,
                "&:hover": { bgcolor: "#e6b800" },
              }}
            >
              Apply Now
            </Button>

            {/* Benefits */}
            <Typography sx={{ fontWeight: "bold", mb: 1 }}>
              We provide our employees with:
            </Typography>

            <List dense>
              {[
                "Flexible schedules for work-life balance",
                "Competitive industry pay and benefits",
                "Advanced training and career growth",
                "Supportive and professional work environment",
              ].map((item, idx) => (
                <ListItem key={idx} sx={{ pl: 0 }}>
                  <ListItemText primary={`• ${item}`} />
                </ListItem>
              ))}
            </List>

            {/* Training CTA */}
            <Box sx={{ mt: 3 }}>
              <Typography sx={{ mb: 2 }}>
                If you haven’t completed Basic Security Training (BST), our team
                can guide you through the process.
              </Typography>

              <Button
                variant="outlined"
                href="mailto:info@lineguardsecurity.ca"
                sx={{
                  color: "#002147",
                  borderColor: "#002147",
                  fontWeight: "bold",
                  borderRadius: "25px",
                  "&:hover": { bgcolor: "#002147", color: "#fff" },
                }}
              >
                Contact for Training Details
              </Button>
            </Box>
          </Grid>
        </Grid>

        {/* Bottom CTA */}
        <Box sx={{ mt: 8, textAlign: "center" }}>
          <Typography
            sx={{
              mb: 2,
              fontWeight: "bold",
              color: "#002147",
              fontSize: { xs: "20px", md: "26px" },
            }}
          >
            Interested in Joining or Training?
          </Typography>

          <Typography sx={{ mb: 3 }}>
            Contact our recruitment team to learn more about opportunities and
            upcoming training programs.
          </Typography>

          <Button
            variant="outlined"
            href="mailto:info@lineguardsecurity.ca"
            sx={{
              color: "#002147",
              borderColor: "#002147",
              fontWeight: "bold",
              borderRadius: "25px",
              "&:hover": { bgcolor: "#002147", color: "#fff" },
            }}
          >
            Contact the Training Team
          </Button>
        </Box>
      </Container>
    </Box>
  );
}

export default ApplyNow;
